// JS constants matching the breakpoints in breakpoints.scss

export const XXS = 480;
export const XS = 600;
export const SM_TABLET = 720;
export const SM = 840;
export const MD = 960;
export const LG_TABLET = 1024;
export const LG = 1280;
export const XL = 1440;
export const XXL = 1600;
export const XXXL = 1920;
